/* eslint-disable */
import toast from '../../../services/toast';
import { mapGetters } from 'vuex';
import { Datetime } from 'vue-datetime';
import draggable from "vuedraggable";
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { VueEditor } from "vue2-editor";
import createQuizReward from '../../quizRewards/create-quiz-reward/index';
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../../main';

export default {
  name: 'public-edit-quiz',
  components: {
    datetime: Datetime,
    VueEditor,
    draggable,
    'quiz-reward':createQuizReward
  },
  props: [],
  data() {
    return {
      quizData: {
        courseId: '',
        name: '',
        category: '',
        instruction: '',
        quiz_number: 0,
        time_limit:90,
        isActive: false,
        quizId:'',
        create_datetime:'',
        end_datetime:'',
        is_visible:false,
        quiz_reward:[],
        testing_enabled:false,
        show_winners: false
      },
      submitted:false,
      QuizList:null,
      is_active:'',
      coursesCategory: {},
      pub_catID:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:'',
      deleteRewardId:'',
      removeRewardPopupStatus:false,
      testing_enabled:Boolean,
      code:'',
      sectionForQuizList:{},
      sectionForQuizResultsList:[],
      removeSectionOfQuizPopupStatus:false,
      removeSectionOfQuizId:''
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState',
      'getcourseCategoryState',
      'getSectionListForQuizGetters'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    },
    getsectionForQuizList() {
      return this.sectionForQuizList = this.$store.getters.getSectionListForQuizGetters.data
    },
    getsectionForQuizResultsList() {
      if(this.sectionForQuizList != undefined){
        this.sectionForQuizResultsList = this.sectionForQuizList.results
        return
      }
    },
    getQuizDetails() {
      this.$store.dispatch('getQuizDetailsByIdFun', {
        id: this.$route.params.quizId
      }).then((response) => {
        this.quizData.show_winners = this.$store.getters.getQuizDetailsByIdDataState.show_winners;
        this.quizData.name = this.$store.getters.getQuizDetailsByIdDataState.name
        this.quizData.isActive = this.$store.getters.getQuizDetailsByIdDataState.is_active
        this.quizData.is_visible = this.$store.getters.getQuizDetailsByIdDataState.is_visible
        this.quizData.instruction = this.$store.getters.getQuizDetailsByIdDataState.instruction
        this.quizData.category = this.$store.getters.getQuizDetailsByIdDataState.category.id
        this.quizData.quiz_number = this.$store.getters.getQuizDetailsByIdDataState.quiz_number
        this.quizData.time_limit = this.$store.getters.getQuizDetailsByIdDataState.time_limit
        this.quizData.create_datetime = this.$store.getters.getQuizDetailsByIdDataState.start_time
        this.quizData.end_datetime = this.$store.getters.getQuizDetailsByIdDataState.end_time
        this.quizData.quiz_reward = this.$store.getters.getQuizDetailsByIdDataState.rewards
        this.quizData.testing_enabled = this.$store.getters.getQuizDetailsByIdDataState.testing_enabled
        this.code = this.$store.getters.getQuizDetailsByIdDataState.code
      })
    },
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.quizData.quizId = this.$route.params.quizId
    this.getsectionForQuizList
    this.getsectionForQuizResultsList
  },
  methods: {
    getQuizDetailsAgain() {
      this.$store.dispatch('getQuizDetailsByIdFun', {
        id: this.$route.params.quizId
      }).then((response) => {
        this.quizData.quiz_reward = response.data.data.rewards
      })
    },
    getSectionOfQuizAgain() {
      this.$store.dispatch('getSectionListForQuizFun', {
        id: this.$route.params.quizId
      }).then((response) => {
        this.sectionForQuizList = response.data.data
      })
    },
    clearEndTimePointFun(){
      this.quizData.end_datetime = ''
    },
    testingEnabledSwitchFun(quizzId) {
      if (this.quizData.testing_enabled == true) {
        this.testing_enabled = false
      }
      if (this.quizData.testing_enabled == false) {
        this.testing_enabled = true
      }
      let data = {
        testing_enabled:this.testing_enabled
      }
      this.$store.dispatch('updateQuizFun', {
        data: {
          data: data,
          id: quizzId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.testing_enabled = res.data.data.testing_enabled
          toast.success("Testing Enabled Status Updated Successfully");
        }
      }).catch((err) => {})
      return
    },
    QuizVisibleStatusAct(quizzId) {
      if (this.quizData.is_visible === true) {
        this.is_visible = false
      }
      if (this.quizData.is_visible === false) {
        this.is_visible = true
      }
      let data = {
        is_visible: this.is_visible,
        is_active: this.quizData.isActive,
        name: this.quizData.name,
        instruction: this.quizData.instruction,
        category: this.quizData.category,
        quiz_number:this.quizData.quiz_number,
        time_limit: this.quizData.time_limit,
        start_time:this.quizData.create_datetime,
        end_time:this.quizData.end_datetime
      }
      this.$store.dispatch('updateQuizFun', {
        data: {
          data: data,
          id: quizzId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.quizData.is_visible = res.data.data.is_visible
          toast.success("Quiz Visible Status Updated Successfully");
        }
      }).catch((err) => {})
      return
    },
    courseQuizWinnerStatusAct(quizzId) {
      let show_winners = false;
      if (this.quizData.show_winners === true) {
        show_winners = false
      }
      if (this.quizData.show_winners === false) {
        show_winners = true
      }
      let data = {
        show_winners: show_winners
      }
      this.$store.dispatch('updateQuizFun', {
        data: {
          data: data,
          id: quizzId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.quizData.show_winners = res.data.data.show_winners
          toast.success("Quiz Winners Status Updated Successfully");
        }
      }).catch((err) => {})
      return
    },
    courseQuizStatusAct(quizzId) {
      if (this.quizData.isActive === true) {
        this.is_active = false
      }
      if (this.quizData.isActive === false) {
        this.is_active = true
      }
      let data = {
        is_active: this.is_active,
        name: this.quizData.name,
        instruction: this.quizData.instruction,
        category: this.quizData.category,
        quiz_number:this.quizData.quiz_number,
        time_limit: this.quizData.time_limit,
        start_time:this.quizData.create_datetime,
        end_time:this.quizData.end_datetime,
      }
      this.$store.dispatch('updateQuizFun', {
        data: {
          data: data,
          id: quizzId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.quizData.isActive = res.data.data.is_active
          toast.success("Quiz Status Updated Successfully");
        }
      }).catch((err) => {})
      return
    },
    validateUpdateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            category: this.quizData.category,
            quiz_number:this.quizData.quiz_number,
            start_time:this.quizData.create_datetime,
            time_limit:this.quizData.time_limit,
            code:this.code
          }
          if(this.quizData.end_datetime != null && this.quizData.end_datetime != ''){
            data.end_time = this.quizData.end_datetime;
          }else{
            data.end_time = null
          }
          this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: this.$route.params.quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                toast.success(res.data.msg);
                // this.$router.push('/course/contest/quizzes/category/' + this.pub_catID + '/list/' )
              }
            })
            .catch((err) => {})
          return
        }
      });
    },
    removeRewrdModalOpenFun(id){
      this.deleteRewardId = id
      this.removeRewardPopupStatus = true
      $('body').addClass('createQuizReward')
    },
    removeRewrdModalConfirmation() {
      this.submitted = true;
      this.$store.dispatch('removeQuizRewardPointsByIdFun', {id: this.deleteRewardId}).then((res) => {
          this.getQuizDetailsAgain();
          toast.success(res.data.msg);
          this.closeRemoveRewrdModal()
      }).catch((err) => {})
      return
    },
    closeRemoveRewrdModal(){
      this.deleteRewardId = ''
      this.removeRewardPopupStatus = false
      $('body').removeClass('createQuizReward')
    },
    bulletSort: function(event) {
      if (event.moved && event.moved != undefined) {
        this.updateTabIndex(event.moved.element.id, Number(event.moved.newIndex) + 1);
      }
    },
    updateTabIndex(tabId, rowIndex) {
      let data = {
        index: rowIndex
      }
      this.$store.dispatch('updateIndexQuizRewardPointsByIdFun', {
          data: {
            data: data,
            id: tabId
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getQuizDetailsAgain();
        })
        .catch((err) => {})
    },
    removeSectionOfQuizModalOpenFun(id){
      this.removeSectionOfQuizId = id
      this.removeSectionOfQuizPopupStatus = true
      $('body').addClass('createQuizReward')
    },
    closeRemoveSectionOfQuizModal(){
      this.removeSectionOfQuizId = ''
      this.removeSectionOfQuizPopupStatus = false
      $('body').removeClass('createQuizReward')
    },
    removeSectionOfQuizModalOpenFunConfirmation() {
      this.submitted = true;
      this.$store.dispatch('removeSectionDetailsByIdForQuizFun', {id: this.removeSectionOfQuizId}).then((res) => {
        this.getSectionOfQuizAgain();
        toast.success(res.data.msg);
        this.closeRemoveSectionOfQuizModal()
      }).catch((err) => {})
      return
    },
    bulletSortSectionOfQuiz: function(event) {
      if (event.moved && event.moved != undefined) {
        this.updateSectionOfQuizIndex(event.moved.element.id, Number(event.moved.newIndex) + 1);
      }
    },
    updateSectionOfQuizIndex(tabId, rowIndex) {
      let data = {
        index: rowIndex
      }
      this.$store.dispatch('updateSectionDetailsByIdForQuizFun', {
          data: {
            data: data,
            id: tabId
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getSectionOfQuizAgain();
        })
        .catch((err) => {})
    },
  },
  beforeMount() {
    this.getQuizDetails
    this.getCourseList
  },
  watch: {
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    },
    getsectionForQuizList() {
      return this.sectionForQuizList = this.$store.getters.getSectionListForQuizGetters.data
    },
    getsectionForQuizResultsList() {
      if(this.sectionForQuizList != undefined){
        this.sectionForQuizResultsList = this.sectionForQuizList.results
        return
      }
    },
  }
}
